import React from 'react'
import styled from 'styled-components'
import { Box } from '../../../../shared_components/UI/Box'
import { loadingPlaceholderAnimation } from '../../../../theme'

const Container = styled.div`
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  width: 300px;
  margin-right: 10px;
  margin-bottom: 64px;
`

export const LoadingPlaceholder = styled.div<{
  height?: number
  width?: number
  isTokenLogo?: boolean
  borderRadius?: number
}>`
  background: ${({ theme }) => theme.colors.loadingPlaceholderBG};
  overflow: hidden;
  border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : '0')}px;
  position: relative;
  height: ${({ height }) => height ? `${height}px` : '100%'};
  width: ${({ width }) => width ? `${width}px` : '100%'};
  ${({ width }) => loadingPlaceholderAnimation(width ? 510 / width : 1)};
`

const Featured = () => {
  return (
    <Container>
      <LoadingPlaceholder width={290} height={181} />
      <Box marginTop={16}>
        <LoadingPlaceholder width={48} height={48} />
      </Box>
      <Box marginTop={16} direction="column">
        <LoadingPlaceholder width={278} height={12} borderRadius={100} />
        <Box marginTop={8} direction="column">
          <LoadingPlaceholder width={245} height={12} borderRadius={100} />
        </Box>
        <Box marginTop={8} direction="column">
          <LoadingPlaceholder width={152} height={12} borderRadius={100} />
        </Box>
      </Box>
      <Box marginTop={32} direction="column">
        <Box marginTop={8} justify="space-between">
          <LoadingPlaceholder width={88} height={12} borderRadius={100} />
          <LoadingPlaceholder width={37} height={12} borderRadius={100} />
        </Box>
        <Box marginTop={8} justify="space-between">
          <LoadingPlaceholder width={88} height={12} borderRadius={100} />
          <LoadingPlaceholder width={37} height={12} borderRadius={100} />
        </Box>
        <Box marginTop={8} justify="space-between">
          <LoadingPlaceholder width={76} height={12} borderRadius={100} />
          <LoadingPlaceholder width={70} height={12} borderRadius={100} />
        </Box>
      </Box>
    </Container>
  )
}

export default Featured
